module.exports = __webpack_public_path__ + "img/r1.d875fe90.png";